'use strict';

/**
 * footer decorator implementation for the accordion module.
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.Accordion.HomeStage = T.createDecorator({

	_selectors: {
		segment: '[data-js-o-accordion__segment-wrapper]',
		panel: '[data-js-o-accordion__panel]',
		toggle: '[data-js-o-accordion__toggle]'
	},

	_stateClasses: {
		open: 'state-open',
		closed: 'state-closed'
	},

	_eventNames: {
		button: 'slide-button',
		interval: 'slide-interval',
		autoplay: 'slide-autoplay'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$segments = this.$ctx.find(this._selectors.segment);
		this.$panels = this.$ctx.find(this._selectors.panel);
		this.currentSlideSet = 0;
		this.currentIndex = 0;

		this.isDesktop = false;
		this.smallVpHasBeenActive = false;

		// Global Event Binding
		this._events.on('viewport.match', this.onViewportMatch.bind(this));
		this._events.on(this._eventNames.interval, this.onSlideInterval.bind(this));

		this.$segments.hover(this.onSegmentMouseOver.bind(this), this.onSegmentMouseOut.bind(this));

		this._parent.start(resolve);
	},


	/**
  * Handle the click on the accordion toggle, overrides the parent method to be able to add VP depending behaviour
  *
  * @param {Object} event The event.
  * @returns {void}
  */
	handleClick: function handleClick(event) {
		if (!this.isDesktop) {
			// we only need the click handling on small screen
			this._parent.handleClick(event);
			return;
		}

		var $currentSegment = $(event.target).closest(this._selectors.segment);
		var $currentToggle = $currentSegment.find(this._selectors.toggle);
		var newSegmentIndex = $currentToggle.data('index');

		// calculate new slide index based on the last autoplay slide
		var newSlideIndex = this.currentSlideSet * 3 + newSegmentIndex;

		this.showPanel($currentSegment);

		if (this.isDesktop) {
			this._events.emit(this._eventNames.button, newSlideIndex);
		}
	},


	/**
  * Event from the stage when the slide changed by interval
  *
  * @param {Object} index The index of the new slide.
  * @returns {void}
  */
	onSlideInterval: function onSlideInterval(index) {
		var segmentIndex = index % 3;
		var $currentToggle = this.$ctx.find(this._selectors.toggle + '[data-index="' + segmentIndex + '"]');
		var $currentSegment = $currentToggle.closest(this._selectors.segment);

		this.currentSlideSet = parseInt(index / 3, 10);
		this.currentIndex = index;

		if (this.isDesktop) {
			this.showPanel($currentSegment);
		}
	},


	/**
  * Handle the change to mediup-up viewport and show the correct panel
  *
  * @returns {void}
  */
	setupDesktopBehaviour: function setupDesktopBehaviour() {
		this.isDesktop = true;

		if (this.smallVpHasBeenActive) {
			this.smallVpHasBeenActive = false;

			// find currently active image and set according segment to active
			var segmentIndex = this.currentIndex % 3;
			var $currentToggle = this.$ctx.find(this._selectors.toggle + '[data-index="' + segmentIndex + '"]');
			var $currentSegment = $currentToggle.closest(this._selectors.segment);

			this.$segments.on('mouseover', this.onSegmentMouseOver.bind(this));

			this.showPanel($currentSegment);
		}
	},


	/**
  * Handle the change to phone-down viewport and remove active classes
  *
  * @returns {void}
  */
	setupMobileBehaviour: function setupMobileBehaviour() {
		this.isDesktop = false;
		this.smallVpHasBeenActive = true;

		this.$segments.removeClass('state-active');
		this.$panels.removeClass('state-active');

		this.$segments.off('mouseover');
	},


	/**
  * Show the new accordion panel and mark the toggle as active
  *
  * @param {Object} $currentSegment The current segment.
  * @returns {void}
  */
	showPanel: function showPanel($currentSegment) {
		this.$segments.removeClass('state-active');
		this.$panels.removeAttr('style');
		$currentSegment.addClass('state-active');
	},


	/**
  * Event when the user enters one of the segments with the mouse
  *
  * @param {Event} ev The event
  * @returns {void}
  */
	onSegmentMouseOver: function onSegmentMouseOver(ev) {
		var currentTarget = $(ev.currentTarget);

		// when the user enters the currently active segment, we pause the autoplay
		if (currentTarget.hasClass('state-active')) {
			this._events.emit(this._eventNames.autoplay, false);
		}
	},


	/**
  * Event when the user exits one of the segments with the mouse
  *
  * @param {Event} ev The event
  * @returns {void}
  */
	onSegmentMouseOut: function onSegmentMouseOut(ev) {
		var currentTarget = $(ev.currentTarget);

		// when the user exits the currently active segment, we continue the autoplay
		if (currentTarget.hasClass('state-active')) {
			this._events.emit(this._eventNames.autoplay, true);
		}
	},


	/**
  * Event from enquire when a certain viewport is detected
  *
  * @param {Object} wpName The detected viewport.
  * @returns {void}
  */
	onViewportMatch: function onViewportMatch(wpName) {
		switch (wpName) {
			case 'small-down':
				this.setupMobileBehaviour();
				break;
			case 'medium-up':
				this.setupDesktopBehaviour();
				break;
			default:
				break;
		}
	}
});